/**
 * CARRITO-UX-P1-T1 (resto; D #30631): el mismo producto puede ir en VARIAS lineas, cada una con su nota.
 *
 * Antes cada producto era UNA linea (se buscaba por id): "2 hamburguesas, una sin cebolla" no se podia pedir. D midio
 * (#30631, main be083c4) que el escritorio recibe un PedidoItem por elemento de items[] con su nota, guarda una fila
 * por item y las abre en caja sin fusionar: las lineas separadas llegan separadas.
 *
 * Cada linea lleva `lid` (su identidad); `id` sigue siendo el producto (lo que viaja como producto_id).
 * Agregar desde el catalogo suma a la linea SIN nota de ese producto (o crea una); nunca a una con nota.
 * Sin DOM: lo prueba check-carrito-notas.
 *
 * @module application/carrito/lineasDelPedido
 */

let siguiente = 0;
const nuevoLid = () => `l${Date.now().toString(36)}${(siguiente++).toString(36)}`;
const sinNota = (l) => !String(l.nota || '').trim();

/** Agrega una unidad del producto: a su linea sin nota, o en una linea nueva. Devuelve el carrito (mismo arreglo). */
export function agregarUnidad(cart, producto) {
  const libre = cart.find((l) => l.id === producto.id && sinNota(l));
  if (libre) libre.qty++;
  else cart.push({ ...producto, qty: 1, nota: '', lid: nuevoLid() });
  return cart;
}

/**
 * Quita una unidad del producto (desde el catalogo): de su ultima linea SIN nota (obs de Q #30657: antes era la
 * ultima linea, que podia ser la de "sin cebolla"); si no hay linea sin nota, de la ultima. En 0, la linea sale.
 */
export function quitarUnidad(cart, productoId) {
  let i = -1;
  for (let k = cart.length - 1; k >= 0; k--) {
    if (cart[k].id !== productoId) continue;
    if (i < 0) i = k;
    if (sinNota(cart[k])) { i = k; break; }
  }
  if (i < 0) return cart;
  if (cart[i].qty > 1) cart[i].qty--; else cart.splice(i, 1);
  return cart;
}

/** Unidades del producto sumando todas sus lineas (lo que muestra la tarjeta del catalogo). */
export function unidadesDe(cart, productoId) {
  return cart.filter((l) => l.id === productoId).reduce((s, l) => s + l.qty, 0);
}

export const lineaPorLid = (cart, lid) => cart.find((l) => l.lid === lid) || null;

/** Cambia la cantidad de UNA linea; 0 o menos la quita. */
export function cantidadDeLinea(cart, lid, qty) {
  const i = cart.findIndex((l) => l.lid === lid);
  if (i < 0) return cart;
  if (qty <= 0) cart.splice(i, 1); else cart[i].qty = qty;
  return cart;
}

export function quitarLinea(cart, lid) {
  const i = cart.findIndex((l) => l.lid === lid);
  if (i >= 0) cart.splice(i, 1);
  return cart;
}

/**
 * "Separar con otra nota": saca UNA unidad de la linea a una linea nueva del mismo producto, sin nota, justo debajo.
 * Solo si la linea tiene mas de una unidad. Devuelve el lid nuevo (o null).
 */
export function separarUnidad(cart, lid) {
  const i = cart.findIndex((l) => l.lid === lid);
  if (i < 0 || cart[i].qty < 2) return null;
  cart[i].qty--;
  const nueva = { ...cart[i], qty: 1, nota: '', lid: nuevoLid() };
  cart.splice(i + 1, 0, nueva);
  return nueva.lid;
}

/**
 * Que viaja en producto_id (T169, OK Ares #36322): el id LOCAL del escritorio como numero. El producto que viene
 * por la API trae `idDesktop` (numero o null); `id` puede ser el codigo y no se manda. El respaldo del sync viejo no
 * trae idDesktop: sigue mandando su id como antes (no se adivina cual campo es el id local ahi).
 */
export function productoIdDelPedido(c) {
  return Object.prototype.hasOwnProperty.call(c, 'idDesktop') ? c.idDesktop : c.id;
}

/** El detalle del pedido: una entrada por LINEA (el escritorio no las fusiona). */
export function detalleDelPedido(cart) {
  return cart.map((c) => ({ producto_id: productoIdDelPedido(c), nombre_producto: c.nombre, cantidad: c.qty, precio: c.precio, notas: String(c.nota || '').trim() }));
}
